import { PopupWrapper } from "@acme/ui";
import { ChatBubble, ChatConversation, ChatListWithFolders } from "../chat";
import { ChatAction } from "../chat/ChatAction";
import { ChatSettings } from "../chat/ChatSettings";
import { ChatTitle, ChatTitleMenu } from "../chat/ChatTitle";
import { LayoutMain } from "./LayoutMain";

/**
 * LayoutChat - Main layout component for the chat interface
 * 
 * This component structures the chat UI with a left sidebar for chat history,
 * a main conversation area, and chat settings.
 * 
 * Now uses ChatListWithFolders for folder organization support.
 */
export function LayoutChat() {
  return (
    <LayoutMain
      leftMenu={<ChatListWithFolders />}
      title={<ChatTitle />}
      titleMenu={<ChatTitleMenu />}
      leftMenuAction={<ChatAction />}
    >
      <div className="flex flex-col gap-3 pb-32 transition-all duration-200 ease-in-out">
        <ChatConversation />
        <ChatSettings />
      </div>
    </LayoutMain>
  );
}

